let _navigator: any = null

export const setGlobalNavigator = (navigator: any) => {
  _navigator = navigator
}

export const globalNavigate = (path: string, options?: any) => {
  if (_navigator) {
    _navigator(path, options)
  } else {
    window.location.href = path
  }
}
